// Module
var code = `<label class="switch"> <input type="checkbox" ng-model="model" ng-checked="{{model}}" class="checkbox-input"> <span class="slider round"></span> </label>`;
// Exports
var _module_exports =code;;
var path = '/common/directives/sInputSwitch/sInputSwitchTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;